import { UserInfo } from "../components/contact/UserInfo";
import { StatusV2 } from "./StatusV2";
import { Payment } from "../components/Payment";
import { LuggageDetails, Transport } from "./Transport";
import { Transfer } from "./Transfer";
import { PaymentConditions } from "../enums/WiypEnum";

export interface Booking {
    boReference: string;
    liheId: number;
    packageId?: string;
    numberOfPax: number;
    reservationDate?: string;
    departureDate: string;
    returnDate: string;
    version?: number;
    transport?: any; // todo
    website: string;
    travellers: Traveller[];
    status: StatusV2;

    reference?: string;
    extReferenceBO?: string | null;
    liheName?: string | null;
    stationName?: string | null;
    site?: string | null;
    agentId?: string | null;
    agentDate?: string | null;
    campaign?: string | null;
    campaignPersistente?: string | null;

    isQuote?: boolean | null;

    channel?: string | null;
    marging?: number | null;
    origin?: string | null;
    destination?: string | null;
    packageCode?: string | null;
    placeId?: number | null;
    promocode?: {
        code: string;
        percentage: number;
        amount?: number;
        codeIresa?: string | null;
    }
    promoCodeDiscount?: string | null;

    sellingPrice?: number | null;
    purchasePrice?: number | null;
    publicPrice?: number | null;
    leftToPay?: number | null;
    source?: string | null;
    updateDate?: string | null;
    updatedAt?: string | null;

    syncDate?: string | null;
    zeroCode?: string | null;
    covid?: boolean | null;
    pack?: 'yes' | 'no' | null;
    ownerAgentId?: number | null;
    partner?: string | null;
    partnerId?: number | null;

    cancellationDate?: string | null;
    transformationDate?: string | null;
    discount?: string | null;
    negativeDiscount?: string | null;
    providerDiscount?: string | null;
    clientEmail?: string | null;

    qrcode?: string | null;
    createVersionDate?: string | null;
    OrderId?: string | null;
    paymentLink?: string | null;
    quoteLink?: string | null;
    options?: Option[];
    payments?: Payment[];
    paymentConditions?: PaymentConditions;
    cancellationUntil?: string;
    optionsChanges?: any[];

    client?: Client;
    company?: string;
}


export interface Flight {
    flightId: number;
    flightNumber: string | null;
    flightDate: string | null;
    [key: string]: any;
}

// export interface Transfer {
//     transferId: number;
//     transferNumber: string | null;
//     transferDate: string | null;
// }


export interface Train {
    trainId: number;
    trainNumber: string | null;
    trainDate: string | null;
}





export interface Client {

    id: string;
    city: string;
    country: string;
    departement: string;
    region: string;
    zipCode: string;
    email: string;
    firstname: string;
    lastname: string;
    street: string;
    mobile: string;
}

export interface Traveller {
    id: string;
    birthday: string;
    bookingReference?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    type?: string | null;
    fulfilled?: boolean | null;
    gender?: string | null;
    luggageGroupIds?: number[];
}

export interface PricePerTraveller {
    id: string;
    price: number;
    selected: boolean;
}

export interface Option {
    id: string;
    quantity: number;
    startDate?: string | null;
    endDate?: string | null;
    prestId?: number | null;
    prestTypeId?: PrestType | null;

    default?: boolean | null;
    mandatory?: boolean | null;
    nominative?: boolean | null;
    cache?: boolean | null;

    bookingReference?: string | null;
    commission?: number | null;
    familyId?: number | null;
    name?: string | null;
    providerId?: number | null;
    providerReference?: string[] | null;
    publicPrice?: number | null;
    purchasePrice?: number | null;
    sellingPrice?: number | null;
    tripPrice?: number | null;
    updateDate?: string | null;
    createDate?: string | null;
    crossSell?: boolean | null;
    crossSellAgent?: number | null;
    crossSellQuantity?: number | null;
    promoCodeDiscount?: string | null;
    discount?: string | null;
    negativeDiscount?: string | null;
    providerDiscount?: string | null;
    accountingDateValidity?: string | null;
    cancellationUntil?: string | null;
    accountingReferenceValidity?: string | null;
    accountingReconciliation?: boolean | null;
    travellerIds?: number[] | null;
    paymentCondition?: number | null;
    details?: Transport | Transfer | LuggageDetails | null;
    email?: string | null;
    pricePerTraveller?: PricePerTraveller[];
    maxCapacity?: number;
    // Especially for commercial-discount
    comments?: string | null;
    key?: string | null;
    agentId?: string | null;
    direction?: 'aller' | 'retour' | 'both';
    ttlExpiration?: number | null; // TTL expiration timestamp in milliseconds
    rawPurchasePrice?: number | null;
    rawSellingPrice?: number | null;
    travellers?: string[];
}

export enum PrestType {
    Accomodation = 1,
    Fees = 3,
    Participant = 4,
    Insurance = 6,
    ProduitsAnnexes = 3
}




export class PaymentObjectV2 {
    boReference: string
    timestamp: number
    userInfo: UserInfo
    paymentIntentData: any
    state: Booking;
    status: StatusV2;
    import?: string;
    overbooking?: string;
    error?: string;

    constructor(
        boReference: string,
        timestamp: number,
        userInfo: UserInfo,
        paymentIntentData: any,
        state: Booking
    ) {
        this.boReference = boReference
        this.timestamp = timestamp
        this.userInfo = userInfo
        this.paymentIntentData = paymentIntentData
        this.state = state
        this.status = StatusV2.INIT
    }

    public static build(boReference: string, timestamp: number, userInfo: UserInfo, paymentIntentData: any, state: Booking): PaymentObjectV2 {
        return new PaymentObjectV2(boReference, timestamp, userInfo, paymentIntentData, state)
    }


}

export interface OptionsChanges {
    travellerId: string;
    changes: {
        before: Option;
        after: Option | null;
    }[]
}

// export interface Payment {
//     id: string;

//     bookingReference: string | null;
//     amount: number | null;
//     auxiliaryAccount: string | null;
//     chargeAccount: string | null;
//     currency: string | null;
//     dateExport: string | null;
//     datePayment: string | null;
//     depositBank: string | null;
//     mode: string | null;
//     payment_action: string | null; // Optional field
//     sideAccount: string | null;
//     status: string | null;
//     transactionId: string | null;
// }